<template>
  <div class="subscription-view">
    <div class="subscription-header">
      <h1 class="title">Subscription Plans</h1>
      <div class="period-toggle">
        <span :class="{ active: !isAnnually }">Monthly</span>
        <label class="switch">
          <input type="checkbox" v-model="isAnnually" @change="handleToggle">
          <span class="slider round"></span>
        </label>
        <span :class="{ active: isAnnually }">
          Annually
          <span class="save-badge">Save 20%</span>
        </span>
      </div>
    </div>
    <div class="pricing-wrap" v-if="cards && cards.length > 0">
      <PricingCard v-for="(item, index) in cards" :key="index" :item="item" />
    </div>
  </div>
</template>
<script>
import PricingCard from "@/components/cards/PricingCard.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      isMobile: false,
      cards: [],
      searchQuery: "",
      modalMessage: "Price Successfully Updated",
      loading: true,
      filters: {
        periode: "monthly",
      },
      isAnnually: false,
    };
  },
  methods: {
    async getPlans() {
      await this.fetchSubscriptionPlans({ periode: this.filters.periode });
      const items = this.getSubscriptionPlans;
      if (items?.length == 0) this.cards = [];

      this.cards = items.map((e) => {
        return {
          buttonText: "SUBSCRIBE",
          ...e,
        };
      });
    },
    handleToggle() {
      this.filters.periode = this.isAnnually ? "annually" : "monthly";
    },
    ...mapActions("payments", ["fetchSubscriptionPlans"]),
  },
  computed: {
    ...mapGetters("payments", ["getSubscriptionPlans"]),
  },
  watch: {
    filters: {
      async handler() {
        await this.getPlans();
      },
      deep: true,
      immediate: true,
    },
  },
  async created() {
    await this.getPlans();
  },
  components: {
    PricingCard,
    //InfoModal,
  },
};
</script>
<style scoped>
@import "@/assets/style/customTable.css";

.subscription-view {
  min-height: 100vh;
  padding: 4rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.subscription-header {
  text-align: center;
  margin-bottom: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  font-size: 3rem;
  font-weight: 700;
  background: linear-gradient(135deg, #fff 0%, #a1a1a1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 1rem;
}

.subtitle {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 2rem;
}

.period-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.5rem;
}

.period-toggle span {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.7);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
}

.period-toggle span.active {
  color: white;
  font-weight: 600;
}

.save-badge {
  background: linear-gradient(135deg, #954ce9 0%, #7d32d2 100%);
  padding: 0.2rem 0.7rem;
  border-radius: 12px;
  font-size: 0.8rem;
  margin-left: 0.5rem;
  color: #fff;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(149, 76, 233, 0.15);
  letter-spacing: 0.5px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.1);
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
}

input:checked+.slider {
  background: linear-gradient(135deg, #954ce9 0%, #7d32d2 100%);
}

input:checked+.slider:before {
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.pricing-wrap {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  max-width: 1200px;
}

@media screen and (max-width: 728px) {
  .subscription-view {
    padding: 2rem 0.5rem;
  }

  .title {
    font-size: 2rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .pricing-wrap {
    gap: 1.2rem;
    padding-bottom: 2rem;
  }
}
</style>
